import React from "react";
import { MdAccountCircle } from "react-icons/md";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { observer } from "mobx-react";
import styled from "styled-components";
import ApiKeys from "./ApiKeys";
import GPTChatModal from "./GPTChatModal";
import ApiClient from "utils/ApiClient";

const emails = ['siddharam@riktamtech.com','prabhat.kumar@riktamtech.com', "aupheesu.pandiri@riktamtech.com"]
const otpEmails = ["siddharam@riktamtech.com"]

function UserMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [modelOpen, setModelOpen] = React.useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const showGPTChats = () => {
    setModelOpen(true);
    handleClose();
  }

  const generateOTP = async () => {
    try {
      let response = await ApiClient.Account.generateOTP();
      if (response.success) {
        window.appStore.notificationStore.showNotification("OTP Generated", "success");
      } else {
        window.appStore.notificationStore.showNotification("Error in generating OTP", "error");
      }
    } catch (error) {
      window.appStore.notificationStore.showNotification("Error in generating OTP", "error");
    }
  };

  return (
    <>
    { modelOpen && 
    <GPTChatModal open={modelOpen} openModal={() => setModelOpen(true)} closeModal={() => setModelOpen(false)} />}
    <StyledMenu>
      <MdAccountCircle
        className="h-100 heading"
        onClick={handleClick}
        style={{
          cursor: "pointer",
          fontSize: 26,
        }}
      />
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        disableAutoFocusItem={true}
      >
        <MenuItem
          onClick={() => {
            const settingsPopup = Ext.create("TL.account.SettingsWindow", {
              id: "account_settings_popup",
              width: 800,
            });
            settingsPopup.show();
            handleClose();
          }}
        >
          Settings
        </MenuItem>
        {props.packStore?.appStore?.userStore?.user?.isAdminForUsers ===
          true && (
          <MenuItem
            onClick={() => {
              const me = this;
              const bilingWindow = Ext.create("TL.Window", {
                title: "Billing",
                cls: "tl-window",
                plain: true,
                width: 1200,
                layout: "fit",
                items: [
                  Ext.create("TL.payments.PaymentMethodsPanel", {
                    //itemId: "action-panel-" + action,
                    listeners: {
                      close: function () {
                        this.fireEvent("close");
                      },
                      scope: this,
                    },
                  }),
                ],
              });

              bilingWindow.show();
              handleClose();
            }}
          >
            Billing
          </MenuItem>
        )}
        {props.packStore?.appStore?.userStore?.user?.canViewUsers === true && (
          <MenuItem
            onClick={() => {
              props.packStore?.appStore.routerHistory.push(`/pack/system/`);
              handleClose();
            }}
          >
            Manage Users
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleClose();
            const importForm = Ext.create("TL.variables.List", {
              bodyStyle: "padding:10px",
              autoHeight: true,
              border: false,
              list: {
                id: props.packStore.listId,
              },
              listeners: {
                success: Ext.bind(function () {
                  variablesWindow.close();
                }, this),
                close: Ext.bind(function () {
                  variablesWindow.close();
                }, this),
                scope: this,
              },
            });

            let variablesWindow = Ext.create("TL.Window", {
              width: 800,
              minHeight: 400, 
              title: "Variables",
              border: false,
              helpLinkIdentifier: "variables",
              items: [
                {
                  xtype: "panel",
                  border: false,
                  items: [importForm],
                },
              ],
            });

            variablesWindow.show();
          }}
        >
          {props.packStore.listId ? "Sheet Variables" : "Global Variables"}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            window.open("https://tigersheet.helpscoutdocs.com", "_blank");
          }}
        >
          Help
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleDialogOpen();
          }}
        >
          API Keys
        </MenuItem>
        <MenuItem
          onClick={() => {
            const url = (process.env.NODE_ENV === "development" ? "http://localhost:3000" : props.packStore.appStore?.configStore?.config?.site?.server_url) + "/api/docs";
            window.open(url, "_blank");
            // props.packStore?.appStore.routerHistory.push("/api/docs");
            
            handleClose();
          }}
        >
          API Docs
        </MenuItem>
        {
          emails.includes(props.packStore?.appStore?.userStore?.user?.email) &&
          ["https://riktam.tigersheet.com", "https://riktam.testbed2.tigersheet.com"].includes(window.appStore?.configStore?.config?.site?.server_url) && 
            (
              <MenuItem
                onClick={() => {
                  showGPTChats();
                }}
              >
                Chats from all domains
              </MenuItem>
            )
        }
        {
          otpEmails.includes(props.packStore?.appStore?.userStore?.user?.email) &&
            ["https://riktam.tigersheet.com", "https://riktam.testbed2.tigersheet.com"].includes(
              window.appStore?.configStore?.config?.site?.server_url
            ) &&
             (
              <MenuItem
                onClick={() => {
                  handleClose();
                  generateOTP();
                }}
              >
                Generate OTP
              </MenuItem>
            )
        }
        <MenuItem
          onClick={() => {
            handleClose();
            window.location.href = baseUrl + "/logout";
          }}
        >
          Logout
        </MenuItem>
        <Separator></Separator>
        <StyledMenuItem onClick={handleClose}>
          {props.packStore?.appStore?.userStore?.user?.email}
        </StyledMenuItem>
      </Menu>
    </StyledMenu>
    {openDialog &&
      <ApiKeys
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        packStore={props.packStore}
      />
    }
    </>
  );
}

const Separator = styled.div`
  margin-top: 5px;
  border-bottom: 1px solid #e0dcdc;
  margin-left: 16px;
  margin-right: 16px;
`;

const StyledMenu = styled.div`
  padding-right: 20px;
`;

const StyledMenuItem = styled(MenuItem)`
  margin-top: 10px;
`;

export default observer(UserMenu);
